var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-table',{attrs:{"url":_vm.url,"title":"گردش حساب","fields":_vm.fields,"params":_vm.params},on:{"updateListResult":_vm.updateListResult}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }